import { HttpErrorResponse } from '@angular/common/http'
import { camelCase, mapKeys, mapValues } from 'lodash'
import { BaseOutput, isBaseOutput, isBaseOutputError } from './base-output.model'
import { GenericValidationErrorPayload } from './mycicero-web-api-errors.model'

export interface Dictionary<T> {
  [id: string]: T
}

export interface InputValidationError {
  Code: string
  Error: string
}

export interface ValidationErrorOutput extends BaseOutput {
  ValidationError?: Dictionary<InputValidationError[]>
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isValidationErrorOutput = (obj: any): obj is ValidationErrorOutput => {
  if (isBaseOutput(obj) && obj.Success === false) {
    if (obj['ValidationError']) {
      return true
    }
  }
  return false
}

export const isValidationErrorResponse = (response: HttpErrorResponse) =>
  response.status === 400 && isValidationErrorOutput(response.error)

export const isFieldValidationErrorResponse = (response: HttpErrorResponse): boolean =>
  response.status !== 200 && isBaseOutputError(response.error)

export const mapValidationErrorOutput = (output: ValidationErrorOutput): GenericValidationErrorPayload => ({
  errors: mapKeys(
    mapValues(output.ValidationError, (value) => value.map((err) => ({ code: err.Code, message: err.Error }))),
    (_, key) => camelCase(key),
  ),
})
